import request from '@/util/request';

// 获取业务报表
export const getBusinessDataApi = (params, options) =>
  request.get('/api/v4ward/plan/page', Object.assign({}, options, { params }));
